import { Component } from 'react';

export default class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[GlobalErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          background: '#f0ede8',
          textAlign: 'center',
          fontFamily: "'DM Sans', sans-serif",
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#2F2B5F', marginBottom: '1rem', fontFamily: "'Cormorant Garamond', serif" }}>
            Algo deu errado ao carregar o app.
          </h2>
          <p style={{ color: '#6b6580', fontSize: '0.9rem', maxWidth: 320, marginBottom: '2rem' }}>
            {this.state.error?.message || 'Erro inesperado. Tente recarregar a página.'}
          </p>
          <button
            style={{
              background: '#F2B198',
              color: '#2F2B5F',
              border: 'none',
              borderRadius: '2rem',
              padding: '0.85rem 2.5rem',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
            }}
            onClick={() => window.location.reload()}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
